import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageHero, Eyebrow } from "../components/Section";
import { INDUSTRIES } from "../lib/content";

export default function Industries() {
  return (
    <div data-testid="industries-page">
      <PageHero
        eyebrow="Industries"
        num="01"
        title={<>Industries <span className="italic text-[var(--bjc-gold)]">we serve</span>.</>}
        intro="Specialist advisory tailored to the financial crime risk profile, regulatory environment, and operational realities of each sector."
      />

      <section className="bjc-section">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[var(--bjc-border)] border border-[var(--bjc-border)]">
            {INDUSTRIES.map((ind, i) => (
              <Link
                key={ind.title}
                to="/contact"
                data-testid={`industry-card-${i}`}
                className="bjc-card p-10 md:p-14 group min-h-[320px] flex flex-col justify-between"
              >
                <div className="flex items-start justify-between">
                  <span className="bjc-numeral">— 0{i + 1}</span>
                  <ArrowUpRight
                    size={18}
                    className="text-[var(--bjc-text-muted)] group-hover:text-[var(--bjc-gold)] group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all"
                  />
                </div>
                <div className="mt-10">
                  <h2 className="font-serif-display text-3xl md:text-4xl lg:text-5xl leading-[1.05] text-[var(--bjc-text)]">
                    {ind.title}
                  </h2>
                  <p className="mt-6 text-base md:text-lg text-[var(--bjc-text-muted)] leading-relaxed max-w-md">
                    {ind.body}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="bjc-section border-t border-[var(--bjc-border)]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 text-center">
          <Eyebrow num="02" className="justify-center">Cross-Sector Practice</Eyebrow>
          <h2 className="mt-6 font-serif-display text-3xl md:text-5xl leading-[1.05] text-[var(--bjc-text)] max-w-[28ch] mx-auto">
            Where regulated activity, cross-border flows, and growth meet — financial crime risk follows.
          </h2>
          <div className="mt-10">
            <Link to="/contact" data-testid="industries-cta" className="bjc-btn-primary">
              Discuss Your Sector
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
